module.exports = __webpack_public_path__ + "static/media/lung-1.5a847cb5.png";